import React, { Children, forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { STEPS_STATUS } from '../utils/constant'
import mapCloneElement from '../utils/mapCloneElement'

const { COMPLETE, PENDING, IN_PROGRESS, ERROR } = STEPS_STATUS

const CustomSteps = forwardRef((props, ref) => {
    const {
        className,
        children,
        current,
        status,
        stepNumber,
        onChange,
        ...rest
    } = props

    const count = Children.count(children)

    const items = mapCloneElement(children, (item, index) => {
        const itemStyles = {
			flexBasis: index < count - 1 ? `${100 / (count - 1)}%` : undefined,
			maxWidth: index === count - 1 ? `${100 / count}%` : undefined
		}
        const itemProps = {
            ...item.props,
            stepNumber: index + 1,
            status: PENDING,
            style: itemStyles,
            isLast: index === count - 1,
            className: classNames(
                item.props.className,
                index === current && 'custom-step-item-current'
            ),
            onStepChange: onChange && index < current ? () => onChange(index) : undefined,
            ...item.props
        }

        if (status === ERROR && index === current) {
            itemProps.className = classNames('custom-steps-item-error')
        }

        if (!item.props.status) {
            if (index === current) {
                itemProps.status = status;
                itemProps.className = classNames(itemProps.className, 'custom-steps-item-active')
            } else if (index < current) {
                itemProps.status = COMPLETE
            }
        }
        return itemProps
    })

    return (
        <div ref={ref} className={classNames('customSteps', className)} {...rest}>
            {items}
        </div>
    )
})

CustomSteps.defaultProps = {
    status: IN_PROGRESS,
    current: 0
}

CustomSteps.propTypes = {
    current: PropTypes.number,
    status: PropTypes.oneOf([COMPLETE, PENDING, IN_PROGRESS, ERROR]),
    onChange: PropTypes.func
}

export default CustomSteps;